<div mat-dialog-content [class]="loading ? 'cursor-wait max-h-[80vh]' : 'max-h-[80vh]'">
    <mg-spinner [show]="spinnerLoad"></mg-spinner>
    <div [class]="loading ? 'pointer-events-none' : ''">
        <div class="w-full mx-auto flex flex-col gap-4 max-h-[80vh]"
            [ngClass]="bdArray.length > 0 ? 'max-w-[1200px]' : 'max-w-[500px]'">
            <div class="flex justify-between items-center">
                <h1 mat-dialog-title class="text-base text-mg-accent m-0 !text-base">
                    {{ mode === 'read' ? 'Detalle de actividad' : mode === 'update' ? 'Edición de actividad' : 'Registrar actividad' }}
                    @if(sNombreColaborador){
                    - {{sNombreColaborador | titlecase}}
                    }
                </h1>
                <button (click)="cancel()" class="p-1">
                    <mg-icon iconClass="text-mg-main-blue" iconName="close"></mg-icon>
                </button>
            </div>
            <div
                class="flex flex-col md:flex-row w-full gap-4 max-h-[calc(80vh-180px)] overflow-y-auto md:overflow-hidden">
                <div class="flex-1 min-w-0 pr-2 md:max-h-[calc(80vh-200px)] md:overflow-y-auto"
                    [ngClass]="bdArray.length > 0 ? 'md:max-w-[420px]' : 'w-full'">
                    <div class="flex flex-col gap-4 pr-2">
                        <div class="flex flex-col xs:flex-row gap-2 w-full">
                            <mg-input-date class="w-full xs:w-1/2" label="Fecha" [required]="true"
                                placeholder="DD/MM/AAAA" [mode]="calendarMode" [min]="minDate" [max]="maxDate"
                                [inputControl]="taskForm.get('dFecha_Registro') | formTransform:'formControl'"
                                enableFilter="WITHOUT_MARKS" [aDisabledDays]="oTareoByStatus['WITHOUT_MARKS']"
                                [serie1]="oTareoByStatus['WITHOUT_MARKS']" titleserie1="Marcas incompletas"
                                cssserie1="!bg-mg-gray-light rounded-full p-2" [serie2]="oTareoByStatus['INCOMPLETO']"
                                titleserie2="Incompleto" cssserie2="!bg-mg-yellow rounded-full p-2"
                                [serie3]="oTareoByStatus['FALTA']" titleserie3="Falta Todo"
                                cssserie3="!bg-mg-red rounded-full p-2">
                            </mg-input-date>
                            <mg-input-minutes-task class="w-full xs:w-1/2" label="Minutos" [required]="true"
                                placeholder="00" [mode]="mode" [calculateHours]="true"
                                [inputControl]="taskForm.get('nMinutos') | formTransform:'formControl'"
                                [hintPosition]="isSmallScreen ? 'right' : 'down'" [maxValue]="maxCurrentMinutes"
                                [tasksStatus]="currentValidations?.sEstado_Horario ?? 'SIN_ASISTENCIA'"
                                [hint]="mode !== 'read'"
                                [forceError]="!currentValidations && mode !== 'read'">
                            </mg-input-minutes-task>
                        </div>
                        @if(isProjectModuleActive) {
                        <mg-input-select-group label="Proyecto"
                            [inputControl]="taskForm.get('sCodigo_Proyecto') | formTransform:'formControl'"
                            [required]="true" [mode]="mode" placeholder="Proyecto" [aOpciones]="aProjects">
                        </mg-input-select-group>
                        <mg-input-select label="Requerimiento"
                            [inputControl]="taskForm.get('sCodigo_Requerimiento') | formTransform:'formControl'"
                            [required]="true" [mode]="mode" placeholder="Requerimiento" [isLoading]="loadingRq"
                            [aOpciones]="aRequirementsFiltered">
                        </mg-input-select>
                        <mg-input-select label="Categoría"
                            [inputControl]="taskForm.get('sCodigo_Categoria') | formTransform:'formControl'"
                            [required]="true" [mode]="mode" placeholder="Categoría" [isLoading]="loadingCat"
                            [aOpciones]="aCategoriesFiltered">
                        </mg-input-select>
                        }
                        @if ((taskMessage.length || !!editError) && mode !== 'read') {
                        <div class="flex flex-col gap-2 -mt-8">
                            @if (taskMessage.length) {
                            <mat-hint class="w-full">
                                <div class="rounded-lg p-2 flex items-center gap-2 w-full bg-mg-base-background">
                                    <mg-icon iconClass="text-base text-mg-gray-dark shrink-0" iconName="info"></mg-icon>
                                    <div
                                        class="text-xxs break-words flex flex-col gap-1 font-normal text-left text-mg-gray-dark !text-xxs [&_p]:m-0">
                                        @for (item of taskMessage; track $index) {
                                        <div class="flex gap-1 items-center">
                                            <div [innerHtml]="item.sMessage"></div>
                                        </div>
                                        }
                                    </div>
                                </div>
                            </mat-hint>
                            }
                            @if(!!editError){
                            <mat-hint class="w-full">
                                <div class="rounded-lg p-2 flex items-center gap-2 w-full bg-mg-danger-light">
                                    <mg-icon iconClass="text-base text-mg-danger-dark shrink-0" iconName="warning"></mg-icon>
                                    <div
                                        class="text-xxs break-words font-normal text-left text-mg-danger-dark !text-xxs [&_p]:m-0">
                                        <div [innerHtml]="editError"></div>
                                    </div>
                                </div>
                            </mat-hint>
                            }
                        </div>
                        }
                        <div class="flex flex-col xs:flex-row xs:gap-2">
                            <mg-input-select label="Tipo de Horas"
                                [inputControl]="taskForm.get('sCodigo_Tipo_Horas') | formTransform:'formControl'"
                                [required]="true" [mode]="typeHourMode" placeholder="Tipo de Horas"
                                [aOpciones]="TIPOS_HORA_ARRAY" [firstValue]="true"
                                [ngClass]="(taskForm.get('sCodigo_Tipo_Horas')?.valid && taskForm.get('sCodigo_Tipo_Horas')?.value && taskForm.get('sCodigo_Tipo_Horas')?.value !== '1' ? 'w-full xs:w-1/2' : 'w-full')">
                            </mg-input-select>
                            @if (taskForm.get('sCodigo_Tipo_Horas')?.valid &&
                            taskForm.get('sCodigo_Tipo_Horas')?.value &&
                            taskForm.get('sCodigo_Tipo_Horas')?.value !== '1' &&
                            !taskForm.get('sCodigo_Tipo_Horas')?.hasError('bIsInvalidOption')) {
                            <mg-time label="Hora de Inicio" [mode]="mode" [required]="true"
                                [inputControl]="taskForm.get('dHora_Inicio') | formTransform:'formControl'"
                                [hint]="false" [hintPosition]="isSmallScreen ? 'right' : 'down'"
                                [messageHint]="sHour_Message!" [currentValidationsDate]="listValidations"
                                class="w-full xs:w-1/2" [autocomplette]="false">
                            </mg-time>
                            }
                        </div>
                        <mg-input-textarea label="Descripción de la actividad" [required]="true"
                            placeholder="Describir actividad" [mode]="mode" [maxlength]="550" class="w-full"
                            [inputControl]="taskForm.get('sDetalle') | formTransform:'formControl'" [minRows]="4"
                            [maxRows]="6">
                        </mg-input-textarea>
                    </div>
                </div>
                <div class="flex-1 md:max-w-[520px] md:max-h-[calc(80vh-200px)] md:overflow-y-auto"
                    [ngClass]="bdArray.length > 0 ? '' : 'hidden'">
                    <div class="flex flex-col gap-3 pr-2">
                        @for (item of bdArray; track $index) {
                        <mg-task-temp-card (toAction)="taskActions($event)" [taskInfo]="item"
                            [isProjectModuleActive]="isProjectModuleActive">
                        </mg-task-temp-card>
                        }
                    </div>
                </div>
            </div>
            <div class="flex flex-col md:flex-row w-full gap-3">
                @if(loading){
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                } @else {
                <div class="flex-1" [ngClass]="bdArray.length > 0 ? 'md:max-w-[420px]' : 'w-full'">
                    <div [class]="!this.taskForm.valid ? 'opacity-75' : 'opacity-100'">
                        @if(mode === 'create'){
                        <button mat-button type="button" (click)="addTask()"
                            class="bg-mg-main-blue rounded-xl text-white font-medium w-full h-10 mat-button flex justify-center items-center !text-base">
                            <mg-icon iconClass="text-white" iconName="add_circle"></mg-icon>
                            &nbsp; Agregar actividad
                        </button>
                        } @else if(mode === 'update') {
                        <div class="flex gap-3 w-full">
                            <button mat-button type="button" (click)="isEditRawTask ? cancel() : resetChanges()"
                                class="text-mg-accent hover:bg-mg-preload border-mg-main-blue-light border-2 font-medium rounded-xl h-10 text-sm w-1/2 flex justify-center items-center !text-sm">
                                Cancelar
                            </button>
                            <button mat-button type="button"
                                (click)="isEditRawTask ? editRowTask() : editLocalTask(currentId)"
                                class="bg-mg-main-blue rounded-xl text-white font-medium h-10 text-sm w-1/2 flex justify-center items-center !text-sm">
                                &nbsp; Guardar
                            </button>
                        </div>
                        }
                    </div>
                </div>
                @if(bdArray.length > 0){

                <div class="flex flex-1 gap-3 md:max-w-[520px]" [class.hidden]="mode!=='create'">
                    <button mat-button type="button"
                        class="text-mg-accent hover:bg-mg-preload border-mg-main-blue-light border-2 font-medium rounded-xl h-10 text-sm w-1/2 flex justify-center items-center !text-sm"
                        (click)="cancel()">
                        Cancelar
                    </button>
                    <button mat-button type="button" [disabled]="mode!=='create'" (click)="confirmSave()"
                        class="bg-mg-green rounded-xl text-white font-medium h-10 text-sm w-1/2 flex justify-center items-center !text-sm">
                        Registrar actividades
                    </button>
                </div>
                }
                }
            </div>
        </div>
    </div>
</div>